export default __webpack_public_path__ + "8551a9d948838274932453e817c7fd8a.png";